import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://jwinafaddqvhsuweuvxy.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp3aW5hZmFkZHF2aHN1d2V1dnh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1NjgwNDUsImV4cCI6MjA4MTE0NDA0NX0.LX9MvihDYKgfCjfA4qIsICpNb6w1h3fnLJwH410AOLM';

export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://provaplus.devcreate.com.br';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
